module.exports = new __parcel__URL__("throatkick.a242f634.png").toString();